import { Dispatch, Action, MiddlewareAPI } from "redux";
import { RootState } from 'model/state';
import { userSignOut, updateLastActive } from 'actions/Auth';
import moment from 'moment';
import { UPDATE_LAST_ACTIVE, UPDATE_LAST_ACTIVE_SUCCESS, SIGNOUT_USER, SIGNOUT_USER_SUCCESS, CLEAR_MESSAGE } from "constants/ActionTypes";

export const sessionInactiveMiddleware = (store: MiddlewareAPI<Dispatch, RootState>) => (next: Dispatch) => (action: Action) => {
  // Skip following actions:
  if ([
        UPDATE_LAST_ACTIVE,
        UPDATE_LAST_ACTIVE_SUCCESS,
        SIGNOUT_USER,
        SIGNOUT_USER_SUCCESS,
        CLEAR_MESSAGE
      ].includes(action.type)) {
    return next(action);
  }

  const lastActive = store.getState().auth.lastActive;
  if (lastActive && moment(lastActive).add(6, 'hours').isBefore(moment())) {
    store.dispatch(userSignOut());
  } else {
    store.dispatch(updateLastActive());
  }

  return next(action)
}
